import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMinusIconSecondary from './svgs/MinusIconSecondary.js';
import SvgMinusIcon from './svgs/MinusIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var minusIcon = (props => useIcon(SvgMinusIcon, SvgMinusIconSecondary, props));

export { minusIcon as default };
